import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { cssProp } from "./helpers";

const StyledText = styled.div<{
	align?: string;
}>(
	({ align }) => css`
		${cssProp("text-align", align)}
	`
);

export default StyledText;
